import React from 'react';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaDownload } from 'react-icons/fa';

const availableFor = [
  'Senior Backend Roles',
  'Laravel Architecture Consulting',
  'Freelance SaaS Development',
  'API Development',
];

const ContactV2 = () => {
  return (
    <section id="contact-v2" className="py-16 md:py-20 lg:py-24 bg-gradient-to-br from-slate-950 via-blue-900 to-indigo-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="w-full rounded-2xl bg-gray-50 border border-gray-200 p-6 md:p-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="max-w-3xl mx-auto p-6 md:p-10 rounded-xl bg-blue-600 text-white shadow-lg hover:shadow-xl text-center"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 tracking-tight">Contact</h2>
          <div className="w-16 h-1 bg-blue-200 rounded mt-2 mb-6 mx-auto"></div>
          <p className="text-sm md:text-base text-blue-50 mb-6 leading-relaxed">
            Open for long-term product engineering roles and consulting engagements.
          </p>

          <div className="bg-white/10 border border-white/20 rounded-xl p-6 md:p-8 mb-8 text-left">
            <h3 className="text-lg md:text-xl font-semibold mb-4 text-center">Available For</h3>
            <div className="grid sm:grid-cols-2 gap-3">
              {availableFor.map((item) => (
                <div key={item} className="flex items-start gap-2.5">
                  <FaCheckCircle className="text-emerald-300 mt-1 flex-shrink-0" />
                  <span className="text-blue-50">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="mailto:shalender8928@yahoo.com"
              className="inline-flex justify-center w-full sm:w-auto px-6 py-3 rounded-lg bg-white text-blue-700 font-semibold hover:scale-105 transition"
            >
              Email Me
            </a>
            <a
              href="https://www.linkedin.com/in/shalender8928/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex justify-center w-full sm:w-auto px-6 py-3 rounded-lg border border-white font-semibold hover:scale-105 transition"
            >
              LinkedIn
            </a>
            <a
              href="/resume/shalender-kumar-resume.pdf"
              download
              className="inline-flex items-center justify-center w-full sm:w-auto gap-2 px-6 py-3 rounded-lg bg-blue-800/60 border border-white/30 font-semibold hover:scale-105 transition"
            >
              <FaDownload />
              Download Resume
            </a>
          </div>
        </motion.div>
      </div>
      </div>
    </section>
  );
};

export default ContactV2;
